export default __webpack_public_path__ + "static/media/dich_vu_cho_thue_oto_tu_lai.38588237.png";